<template>
  <section class="article-section">
    <div class="container article-flex">
      <div class="img-container">
        <div
          class="img-color-cont"
          :style="{ background: page.post_image_bg }"
        >
          <img
            :src="postImage"
            :alt="altText"
            width="100%"
          />
        </div>
        <span
          v-if="page.post_image_caption"
          class="img-caption"
        >
          {{ page.post_image_caption }}
        </span>
      </div>
      <div class="text-container">
        <h3>{{ page.post_title }}</h3>
        <div
          class="article-content"
          v-html="page.post_text"
        ></div>
        <div class="download">
          <p v-if="page.download_title">{{ page.download_title }}</p>
          <a
            v-if="subscribed"
            class="proxify-btn proxify-btn-no-icon"
            @click="onClickEvent"
          >
            {{ page.download_button_title }}
          </a>
          <button
            v-else
            class="proxify-btn proxify-btn-no-icon"
            @click="onClickEvent"
          >
            {{ page.download_button_title }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import articleSection from './articleSection';

export default {
  mixins: [articleSection],
  emits: ['downloadFile'],
  computed: {
    altText() {
      const text = this.page.post_image_caption || this.page.post_title;
      if (text) {
        // Remove "image" case-insensitive, then trim and remove potential double spaces
        return text.replace(/image/gi, '').replace(/\s\s+/g, ' ').trim();
      }
      return '';
    },
  },
  methods: {
    onClickEvent() {
      this.$analytics.track('CTA Clicked', {
        cta_name: this.page.download_button_title,
        section: 'Article section',
        page_name: 'Lead gen page v1',
      });
      if (this.subscribed) {
        this.$emit('downloadFile');
      } else {
        this.moveToForm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ArticleSection.scss';
</style>
